module.exports = __webpack_public_path__ + "img/1970East-075_WEB-min.a927325b.jpg";